<template>
  <div class="sale-content">
    <div class="sale-inner">
      <img class="brand-logo" src="../assets/login_logo.png" alt="Panda Mandarin">
      <h1 class="sale-title">{{ $t('saleCard.title') }}</h1>
      <p class="sale-desc">{{ $t('saleCard.desc') }}</p>

      <div class="info-box">
        <div class="mandy-msg">
          <div class="lo-icon" v-if="info.email">
            <img src="../assets/img/Message.png" alt="">
            <span class="lo-text">{{ info.email }}</span>
          </div>
          <div class="lo-icon" v-if="info.mobile">
            <img class="mobile" src="../assets/img/Calling.png" alt="">
            <span class="lo-text">{{ info.mobile }}</span>
          </div>
          <div class="lo-icon" v-if="info.wechat">
            <img class="mobile" src="../assets/img/WeChat_logo_icon 1.png" alt="">
            <span class="lo-text">{{ info.wechat }}</span>
          </div>
        </div>

        <div class="m-center" v-if="info.qr_code">
          <div class="qr-code">
            <img class="qr-code-5" :src="info.qr_code" alt="">
          </div>
        </div>
      </div>

      <button type="button" class="sale-cta">{{ $t('saleCard.cta') }}</button>
    </div>
  </div>
</template>

<script>
import '../styles/variable.less'
export default {
  name: 'salecard',
  data () {
    return {
      info: {
        name: '',
        describe: '',
        email: '',
        mobile: '',
        wechat: '',
        qr_code: ''
      },
      invite_code: ''
    }
  },
  mounted () {
    this.invite_code = this.$route.query.invite_code
    this.$http.get('/api/getDealData?invite_code=' + this.invite_code).then((res) => {
      if (res.data.code == 200) {
        this.info = res.data.data
      }
    })
  }
}
</script>

<style lang="less" scoped>
.sale-content {
  min-height: 100vh;
  background: #fffaf2;
  box-sizing: border-box;
  padding: 40px 24px 48px;
}

.sale-inner {
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.brand-logo {
  width: 120px;
  height: auto;
  display: block;
  margin-bottom: 28px;
}

.sale-title {
  margin: 0 0 16px;
  font-size: 22px;
  line-height: 1.4;
  font-weight: 700;
  text-align: center;
  color: #111827;
}

.sale-desc {
  margin: 0 0 28px;
  padding: 0 4px;
  font-size: 14px;
  line-height: 1.7;
  text-align: center;
  color: #4b5563;
}

.info-box {
  width: 100%;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);
  padding: 28px 24px 32px;
  box-sizing: border-box;
}

.mandy-msg {
  width: 100%;
}

.lo-icon {
  display: flex;
  align-items: center;
  margin: 0 0 18px;

  &:last-of-type {
    margin-bottom: 0;
  }

  img {
    width: 20px;
    height: 20px;
    margin-right: 14px;
    flex-shrink: 0;
  }

  .mobile {
    width: 22px !important;
    height: 22px !important;
  }

  .lo-text {
    display: inline-block;
    word-break: break-word;
    font-size: 15px;
    line-height: 1.4;
    font-weight: 600;
    color: #0b1d33;
  }
}

.m-center {
  margin-top: 24px;
}

.qr-code {
  width: 180px;
  height: 180px;
  margin: 0 auto;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .qr-code-1,
  .qr-code-2,
  .qr-code-3,
  .qr-code-4 {
    width: 18px;
    height: 18px;
    position: absolute;
  }

  .qr-code-1 {
    top: 0;
    left: 0;
  }

  .qr-code-2 {
    top: 0;
    right: 0;
  }

  .qr-code-3 {
    bottom: 0;
    left: 0;
  }

  .qr-code-4 {
    bottom: 0;
    right: 0;
  }

  .qr-code-5 {
    width: 146px;
    height: 146px;
    display: block;
  }
}

.sale-cta {
  width: 100%;
  margin-top: 28px;
  height: 52px;
  border: none;
  border-radius: 12px;
  background: #b50604;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
  cursor: default;
}

@media screen and (max-width: 375px) {
  .sale-content {
    padding: 28px 16px 36px;
  }

  .brand-logo {
    width: 100px;
    margin-bottom: 20px;
  }

  .sale-title {
    font-size: 20px;
  }

  .sale-desc {
    font-size: 13px;
    margin-bottom: 22px;
  }

  .info-box {
    padding: 22px 18px 26px;
    border-radius: 14px;
  }

  .lo-icon .lo-text {
    font-size: 14px;
  }

  .qr-code {
    width: 150px;
    height: 150px;

    .qr-code-5 {
      width: 120px;
      height: 120px;
    }
  }

  .sale-cta {
    height: 48px;
    font-size: 15px;
    margin-top: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/salecard.vue